export default "__VITE_ASSET__CfTdvBJY__"